import { IExpertSystemOrder, IExpertSystemRecipient, IListItem } from '@nkr/models/index';
import { Button, Col, Label, Row } from 'react-bootstrap';
import SelectCreateRecipient from './select-create-recipient';
import * as moment from "moment";

interface IProps {
    centerId: number,
    order: IExpertSystemOrder,
    recipientInfo: IExpertSystemRecipient,
    recipientList: IExpertSystemRecipient[],
    genderList: IListItem[],
    stateList: IListItem[],
    hasAllData: boolean,
    dobOutOfBounds: boolean,
    processRecipientForAnalysis: boolean,
    donorAlias: string,
    onDataChange: (data: IExpertSystemRecipient) => void,
    onNoRecipient: () => void,
    onSubmit: () => void,
    onSubmitExistingKit: () => void,
    onSubmitForAnalysis: () => void,
    onReturnHome: () => void
}

const ExpertAnalysisStillPending = (props: IProps) => {
    let { statusId, ordersSent } = props.order;
    let { hasTyping } = props.recipientInfo;
    let showKitButtons = (hasTyping);

    return (
        <div className='container'>
            <div className='row' style={{ marginBottom: 10 }}>
                <div className='col-xs-12' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h1 style={{ margin: 0 }}>Expert System Analysis</h1>
                </div>
            </div>
            <div className='row'>
                <div className='col-xs-12' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    {statusId == 1 && (
                        <div style={{ marginBottom: 20 }}>
                            This analysis is still pending the return of the donor cheek
                            swab. Please follow up with the donor and ask them to perform
                            the cheek swab. The swab was ordered on {moment(ordersSent).format('MM/DD/YYYY')}.
                            Please note it could take as long as 5 business days to
                            receive these results. You may now select a recipient if you
                            would like to accellerate the process.
                        </div>
                    )}
                </div>
                <div className='col-xs-12' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
                    {statusId <= 2 && !props.processRecipientForAnalysis && (
                        <div className='container'>
                            <div className='col-xs-12'>
                                <SelectCreateRecipient
                                    centerId={props.centerId}
                                    recipientInfo={props.recipientInfo}
                                    recipientList={props.recipientList}
                                    genderList={props.genderList}
                                    stateList={props.stateList}
                                    donorAlias={props.donorAlias}
                                    dobOutOfBounds={props.dobOutOfBounds}
                                    orderStatus={statusId}
                                    onDataChange={props.onDataChange}
                                />
                                <Row>
                                    <Col xs={12} lg={12} style={{ textAlign: 'center' }}>
                                        {!showKitButtons && (<>
                                            <Button
                                                disabled={!props.hasAllData}
                                                bsStyle='primary'
                                                style={{ marginRight: 5 }}
                                                onClick={props.onSubmit}
                                            >
                                                Create/Update Demographics and Ship Kits
                                            </Button>
                                            <Button
                                                disabled={!props.hasAllData}
                                                bsStyle='primary'
                                                style={{ marginRight: 5 }}
                                                onClick={props.onSubmitExistingKit}
                                            >
                                                Create/Update Demographics and Use on Hand Bulk Kit
                                            </Button>
                                        </>)}

                                        {showKitButtons && (<>
                                            <Button
                                                disabled={!props.hasAllData}
                                                bsStyle='success'
                                                style={{ marginRight: 5 }}
                                                onClick={props.onSubmitForAnalysis}
                                            >
                                                Typing already on hand, no need to ship a kit. Click to Proceed.
                                            </Button>

                                        </>)}

                                        <Button
                                            bsStyle='primary'
                                            onClick={props.onNoRecipient}
                                        >
                                            This donor has no designated recipient
                                        </Button>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    )}

                    {statusId == 3 && props.order.donorResultsReceived && props.order.recpResultsReceived && (
                        <div style={{ marginBottom: 20 }}>
                            The recipient cheek swab has been received and we are waiting for the analysis to complete. You should receive an email
                            within 24 hours with the results.
                        </div>
                    )}

                    {statusId == 3 && (!props.order.donorResultsReceived || !props.order.recpResultsReceived) && (
                        <div style={{ marginBottom: 20 }}>
                            This analysis is still pending the return of a donor or recipient cheek swab. Please follow up with the donor or recipient and ask them
                            to perform the cheek swab. Please note it could take as long as 5 business days to receive these results once they are shipped back.
                        </div>
                    )}

                    {statusId == 4 && (
                        <div style={{ marginBottom: 20 }}>
                            The recipient cheek swab has been received and we are waiting for the analysis to complete. You should receive an email
                            within 24 hours with the results.
                        </div>
                    )}
                </div>
            </div>

            <div className='row'>
                <div className='col-xs-12' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Button bsStyle='link' onClick={props.onReturnHome}>
                        Return to Expert System DashBoard
                    </Button>
                </div>
            </div>
        </div>
    );
}

export default ExpertAnalysisStillPending;